import {OfferDisplayType} from "../helpers/OfferDisplayType";
import {IOfferDetail} from "../types/IOfferDetail";

type OfferConfiguration = Pick<IOfferDetail, "configuration">;

type UnavailableOfferData = {
    configuration: Pick<OfferConfiguration["configuration"], "limited_presentation" | "display_type">;
};

export function getUnavailableOfferInfo(offer: UnavailableOfferData | null) {
    if (!offer) {
        return {isArchived: false, isUnavailable: false};
    }

    const isLimited = !!offer.configuration.limited_presentation;
    const isForSale = offer.configuration.display_type === OfferDisplayType.FOR_SALE;

    return {
        isArchived: isLimited && !isForSale,
        isUnavailable: isLimited && isForSale
    };
}
import {OfferDisplayType} from "../helpers/OfferDisplayType";
import {IOfferDetail} from "../types/IOfferDetail";

type OfferConfiguration = Pick<IOfferDetail, "configuration">;

type UnavailableOfferData = {
    configuration: Pick<OfferConfiguration["configuration"], "limited_presentation" | "display_type">;
};

export function getUnavailableOfferInfo(offer: UnavailableOfferData | null) {
    if (!offer) {
        return {isArchived: false, isUnavailable: false};
    }

    const isLimited = !!offer.configuration.limited_presentation;
    const isForSale = offer.configuration.display_type === OfferDisplayType.FOR_SALE;

    return {
        isArchived: isLimited && !isForSale,
        isUnavailable: isLimited && isForSale
    };
}
